<template>
	<div class="engine-street-search">
		<div class="row">
			<div class="col " style="display: flex; flex-direcion: row;">
				<input class="form-control" v-model="streetSearchPhrase" placeholder="Ulice" v-on:keyup.enter="fetchStreetNames"/>
				<div class="street-input-hide ml-1" @click="hideStreet"> {{ streetHide ? '▼' : '◄' }} </div>
			</div>
		</div>

		<div class="row mt-2">
			<div class="col " style="display: flex; justify-content: space-between;">
				<button class="btn sedej" @click="fetchStreetNames"> Hledej </button>
				<button v-if="! streetAdding"  v-b-modal.modal-11 class="btn btn sedej"> + </button>

				<button v-if="streetReversed" class="btn btn sedej" @click="streetReverse"> Z -> A </button>
				<button v-else class="btn btn sedej" @click="streetReverse"> A -> Z </button>
			</div>
		</div>

		<div class="row mt-2">
			<div class="col text-left">
				<span class="selected-street"> Vybráno: {{ selectedStreet }} </span>
			</div>
		</div>

		<div class="row" v-show="streetHide" v-if="! searching">
			<div class="col text-left">
				<ul class="list-group my-list">
					<li class="list-group-item cursor-pointer text-left" 
						:class="{ active: isActive(name) }"
						v-for="name of streetNames" :key="name"
						@click="streetSelect(name)"
						> {{ name === '' ? '[Beze jména ulice]' : name }} </li>
				</ul>

			</div>
		</div>

		<div v-show="streetHide" v-else :class="{ streetlistsearching: (! streetAdding), streetlistsearchingadding: streetAdding }">
			<circle-spin :loading="searching"></circle-spin>
		</div>

<!-- 
		<div class="street-input-together">
			<input class="street-input" v-model="streetSearchPhrase" placeholder="Ulice" v-on:keyup.enter="fetchStreetNames"/>
			<div class="street-input-hide" @click="hideStreet"> {{ streetHide ? '▼' : '◄' }} </div>
		</div>
		<div class="street-search-buttons">
			<button class="street-search" @click="fetchStreetNames"> Hledej </button>
			<button v-if="! streetAdding" @click="streetAddingStart" class="street-add"> + </button>

			<button v-if="streetReversed" class="street-reverse" @click="streetReverse"> Z -> A </button>
			<button v-else class="street-reverse" @click="streetReverse"> A -> Z </button>
		</div>
		<span class="selected-street"> Vybráno: {{ selectedStreet }} </span>
		<div v-if="streetAdding" class="street-name-adding"> 
			Přidavam novou ulic
		</div>
		<div  v-show="streetHide" :class="{ streetlist: (! streetAdding), streetlistadding: streetAdding }" v-if="! searching"> 
			<div v-for="name of streetNames" :key="name" class="street-list-item" :class="{ active: isActive(name) }" @click="streetSelect(name)"> {{ name === '' ? '[Beze jména ulice]' : name }} </div>
		</div>
		<div v-show="streetHide" v-else :class="{ streetlistsearching: (! streetAdding), streetlistsearchingadding: streetAdding }">
			<circle-spin :loading="searching"></circle-spin>
		</div>





		<modal
            v-show="isModalVisible"
            @close="closeModal">
            <template v-slot:header class="modal-street-title">  </template>
           	<template v-slot:body> 
				<input v-model="streetAddingName" placeholder="Název nové ulice" class="street-name-adding-input" />	   
			</template>
            <template v-slot:footer class="foo"> <button class="modal-butt-yes" @click="streetDraftNameDone" :disabled="existsSearching"> {{ existsSearching ? 'UKLÁDÁM' : 'Uložit'}} </button> <button class="modal-butt-no" @click="closeModal"> Zrušit </button> </template>
        </modal> -->
		<b-modal id="modal-11" title="BootstrapVue" :size="'lg'" @hidden="resetModal">
			<template #modal-title>
				Přidat novou ulici do města: {{ cityName }}?
			</template>
			<div class="d-block text-center">
				<div class="row">
					<div class="col col-md-6">
						<input v-model="streetAddingName" placeholder="Název nové ulice" class="form-control" />	
					</div>
				</div>
				<div class="row">
					
				</div>
			</div>
			<template #modal-footer>
				<div class="row">
					<button class="btn btn-secondary px-3 py-2 mr-2" @click="streetDraftNameDone" :disabled="existsSearching"> {{ existsSearching ? 'UKLÁDÁM' : 'Uložit'}} </button>
					<button class="btn btn-primary px-3 py-2 mr-2" @click="closeModal"> Zrušit </button>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'

import modal from '@/components/modal.vue';

export default {
    name: 'streetSearch',
	props: {
		cityName: null,
	},
	components: {
        modal,
    },

	data () {
		return {
			streetSearchPhrase: '',
			searching: false,
			selectedStreet: null,
			streetNames: [],
			streetReversed: false,
			streetAdding: false,
			streetAddingName: '',
			existsSearching: false,
			streetHide: true,
			isModalVisible: false,
		}
	},

	async created () {
		this.searching = true
		const hold = await AdditionsService.fetchStreetNames(this.streetSearchPhrase, this.$props.cityName)
		const streetNamesPreSort = hold.data.map((a) => {
			return a.city_street_name
		})

		let streetNamesSorted = streetNamesPreSort.sort()

		if (this.streetReversed) {
			streetNamesSorted = streetNamesSorted.reverse()
		}

		this.streetNames = streetNamesSorted
		this.searching = false
	},	

	methods: {
		showModal(text) {
            // this.displayText = text
            this.isModalVisible = true;
        
        },
        closeModal() {
			this.isModalVisible = false;
			this.$bvModal.hide('modal-11')
			this.streetAddingStop()
		},
		
		resetModal () {
			this.streetAddingName = ''
		},

		hideStreet () {
			this.streetHide = ! this.streetHide
		},

		async streetDraftNameDone () {
			this.existsSearching = true
			const hold = await AdditionsService.streetNameExists(this.streetAddingName, this.$props.cityName)
			this.existsSearching = false

			if (hold.data) {
				this.streetNames.unshift(this.streetAddingName)
				this.streetAdding = false
				this.streetAddingName = ''
				this.streetSelect(hold.data)
			}
			this.isModalVisible = false
			this.$bvModal.hide('modal-11')
			this.$emit('streetAddingDraft', this.streetAddingName)
		},

		streetAddingStart () {
			this.streetAdding = true
			this.selectedStreet = null
			this.$emit('streetAddingStart')
			this.showModal('a')
		},

		streetAddingStop() {
			this.streetAdding = false
			this.streetAddingName = ''
		},

		streetAddingSave() {
		},
		
		streetReverse () {
			this.streetReversed = ! this.streetReversed
			this.streetNames = this.streetNames.reverse()
		},

		async fetchStreetNames () {
			const streetSearchPhrase = this.streetSearchPhrase
			this.searching = true

			const hold = await AdditionsService.fetchStreetNames(streetSearchPhrase, this.$props.cityName)
			const streetNamesPreSort = hold.data.map((a) => {
				return a.city_street_name
			})

			let streetNamesSorted = streetNamesPreSort.sort()

			if (this.streetReversed) {
				streetNamesSorted = streetNamesSorted.reverse()
			}

			this.streetNames = streetNamesSorted
			this.searching = false
		},

		streetSelect (s) {
			this.selectedStreet = s
			this.$emit('streetSelect', s)
		},

		isActive (name) {
			if (name === this.selectedStreet) {
				return true
			}
			return false
		},
		
		async setStreetNames (cityName) {
			this.selectedStreet = null
			this.streetSearchPhrase = ''
			this.searching = true

			const hold = await AdditionsService.fetchStreetNames(this.streetSearchPhrase, cityName)
			const streetNamesPreSort = hold.data.map((a) => {
				return a.city_street_name
			})

			let streetNamesSorted = streetNamesPreSort.sort()

			if (this.streetReversed) {
				streetNamesSorted = streetNamesSorted.reverse()
			}

			this.streetNames = streetNamesSorted
			this.searching = false
		}
	},
}
// TODO stylus css omg
</script>

<style scoped>
.sedej {
	background-color: #cccccc;
}

.engine-street-search {
	display: flex;
	flex-direction: column;
	width: 250px;
	padding: 10px;
	font-family: 'Roboto', sans-serif;
}

.my-list {
	max-height: 300px;
	min-height: 300px;
	overflow-y: scroll;
	background-color: white;
	padding: 0px;
	margin-top: 30px;
	cursor: pointer;
}

.street-input {
	width: 100%;
	height: 40px;
	padding-left: 5px;
	
}

.street-search {
	height: 30px;
}

.street-add {
	height: 30px;
	width: 30px;
}

.street-adding-buttons {
	width: 70px;
}

.street-add-save {
	height: 30px;
	width: 30px;
}

.street-add-remove {
	height: 30px;
	width: 30px;
}

.street-reverse {
	height: 30px;
}

.street-search-buttons {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.street-name-adding {
	height: 40px;
	margin-top: 30px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.street-name-adding-input {
	height: 40px;
	width: 80%;
	padding-left: 20px;
}

.street-name-adding-button {
	height: 40px;
	width: 19%;
}

.streetlist {
	background-color: white;
	width: 100%;
	height: 300px;
	margin-top: 30px;
	overflow-y: scroll;
}

.streetlistadding {
	background-color: white;
	width: 100%;
	height: 260px;
	overflow-y: scroll;
}

.streetlistsearching {
	background-color: #CCE6FF;
	width: 100%;
	height: 300px;
	margin-top: 30px;
}

.streetlistsearchingadding {
	background-color: #CCE6FF;
	width: 100%;
	height: 260px;
}

.street-list-item {
	height: 40px;
	line-height: 40px;
	font-size: 18px;
	border-bottom: 1px solid gray;
	background-color: #CCE6FF;
	text-align: left;
	padding-left: 10px;
	color: rgb(73, 73, 73);
	white-space: nowrap; 
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: pointer;
}

.active {
	background-color: #9CCFFF;
}

.street-input-together {
	display: flex;
	flex-direction: row;
}
.street-input-hide {
	display: none;
}

.selected-street {
	text-align: left;
}

.modal-street-title {
	font-size: 16px;
}

.modal-butt-yes {
    height: 30px;
    width: 120px;
    border: none;
    background-color: #4CA5F9;
    cursor: pointer;

}

.modal-butt-no {
    height: 30px;
    width: 120px;
    border: none;
    background-color: red;
    cursor: pointer;
}



@media (max-width: 1000px) {
	.engine-street-search {
		display: flex;
		flex-direction: column;
		width: 90%;
		padding: 10px;
		font-family: 'Roboto', sans-serif;
		border-bottom: 1px solid gray;

	}

	.street-input-hide {
		display: block;
		width: 40px;
		height: 38px;
		background-color: #cccccc;
		line-height: 40px;
		font-size: 24px;
		cursor: pointer;
		border-radius: 5px;
	}

}

</style>



// WEBPACK FOOTER //
// src/components/engine/streetSearch.vue